<!-- eslint-disable no-tabs -->
<template>
  <div>
    <div class="panel-notification is-scroll"
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loadCheck"
        infinite-scroll-throttle-delay="400"
        infinite-scroll-distance="10"
    >
      <div
        class="list-notification pointer"
        :class="{ 'is-active': isSelectedLog(item.entity_id, item.api_name, item.log_object_id) }"
        v-for="(item, index) in data"
        :key="'notification-list-' + index"
        @click="selectItem(index)"
      >
        <i class="icon-list">
          <svgicon name="icon-rejections" :original="true"/>
        </i>
        <div class="list-content">
          <div>
            <p>
              <strong>
                {{item.entity_id}} : {{item.api_name}}
              </strong>

            </p>
            <p v-if="item.transaction_type === transactionTypes.OUTBOUND">
              {{ $t('INTEGRATION_MITM_STATUS_code') }} :
              <strong>
                {{item.mitm_error_status || item.mitm_async_error}}
              </strong>
            </p>
            <p>
              {{ $t('INTEGRATION_ERP_STATUS_CODE') }} :
              <strong>
                {{item.erp_status_code}}
              </strong>
            </p>
            <p v-if="item.entity_status">
              {{ $t('INTEGRATION_ENTITY_STATUS') }}:
              <strong>
                {{item.entity_status}}
              </strong>
            </p>
          </div>
          <div class="ml-auto text-muted mr-10">
            {{item.updated_at}}
          </div>
        </div>
      </div>
      </div>
      <div v-if="!data.length && isListLoadingCompleted"
      class="status-msg my-sm" size="small" text="top-left" style="width:45%;">
        <div class="status-content">
          <span class="status-inner">
            <img :src="NoData" width="200" height="180" class="img-responsive" alt=""/>
            <p style="width:100px; left:20px;">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
          </span>
        </div>
      </div>
      <div v-if="!isListLoadingCompleted" class="status-msg my-md" style="width:45%;">
        <span>
          <img :src="LoaderCommon" width="240" class="img-responsive" alt=""/>
        </span>
      </div>
  </div>
  </template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import NoData from '@common/asset/images/status-no-data.png';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoaderCommon from '@common/asset/images/loader-common.gif';


import { transactionTypes } from '@/constants/integrations';

export default {
  name: 'entity-list',
  props: {
    data: {
      type: Array,
    },
    isListLoadingCompleted: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedItem: null,
      NoData,
      LoaderCommon,
      transactionTypes,
    };
  },
  computed: {
    isSelectedLog() {
      return ((entityNo, apiName, logObjectId) => !!(this.selectedItem &&
      (this.selectedItem.entity_no || this.selectedItem.entity_id) === entityNo) &&
          !!(this.selectedItem && (this.selectedItem.api_name) === apiName)
          && (this.selectedItem.log_object_id ? this.selectedItem.log_object_id === logObjectId : true));
    },
  },
  methods: {
    loadMore() {
      this.$emit('load-more');
    },
    selectItem(index) {
      this.selectedItem = this.data[index];
      this.$emit('select-item', this.selectedItem);
    },
  },
};
</script>

